/* Keep Zepto's text editor in the font shown by its own selector.
   Use Zepto's own font-selection handler to initialize its preview as well. */
(() => {
  if (window.blijeZeptoFontSync) return;
  window.blijeZeptoFontSync = true;
  const roots = new WeakSet();
  const initializedFonts = new WeakSet();

  function initializePreview(root) {
    if (typeof window.pplrselecteritem !== 'function') return;
    root.querySelectorAll('.pplr-font-select .pplr_font').forEach((field) => {
      if (initializedFonts.has(field)) return;
      const wrapper = field.closest('.pplr-wrapper');
      const frame = wrapper?.dataset.frame;
      // The controls can appear before Zepto has initialized its canvas data.
      if (!window.pplr_values?.[frame]?.[window.pplr_last_idx]) return;
      const selected = wrapper.querySelector('.pplr-selecter-selected');
      const items = [...wrapper.querySelectorAll('.pplr-selecter-item')];
      const item = items.find((option) => option.dataset.value === field.dataset.value)
        || items.find((option) => option.textContent.trim() === selected?.textContent.trim());
      if (!item) return;
      initializedFonts.add(field);
      try {
        // Same path as selecting this font manually: loads the font, updates
        // linked text layers and redraws the product preview after it loads.
        window.pplrselecteritem(item, item.getAttribute('data-pplr_price'));
      } catch (error) {
        initializedFonts.delete(field);
        console.warn('Blije Wolkje: Zepto font initialization deferred.', error);
      }
    });
  }
  const textSelector = 'input.pplr_text:not([type="hidden"]), textarea.pplr_text';

  function sync(root) {
    initializePreview(root);
    const selectors = [...root.querySelectorAll('.pplr-selecter-selected')];
    const inputs = [...root.querySelectorAll(textSelector)];
    inputs.forEach((input, index) => {
      // A single font selector applies to the editor; for multiple editors,
      // use the following selector before the next text input in DOM order.
      const selected = selectors.length === 1 ? selectors[0] : selectors.find((item) =>
        (input.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING) &&
        (!inputs[index + 1] || (item.compareDocumentPosition(inputs[index + 1]) & Node.DOCUMENT_POSITION_FOLLOWING))
      );
      if (!selected) return;
      const family = selected.style.fontFamily || getComputedStyle(selected).fontFamily;
      if (family && input.style.getPropertyValue('--blije-zepto-font') !== family) {
        input.style.setProperty('--blije-zepto-font', family);
      }
    });
  }

  function attach() {
    document.querySelectorAll('.product-personalizer').forEach((root) => {
      if (roots.has(root)) return;
      roots.add(root);
      root.addEventListener('click', (event) => {
        const item = event.target.closest('.pplr-selecter-item');
        const field = item?.closest('.pplr-wrapper')?.querySelector('.pplr_font');
        if (field) initializedFonts.add(field);
      }, true);
      sync(root);
      // Bounded readiness retries cover app scripts that finish without DOM changes.
      let attempts = 0;
      const timer = setInterval(() => {
        if (!root.isConnected || ++attempts >= 120) { clearInterval(timer); return; }
        sync(root);
        const fields = [...root.querySelectorAll('.pplr-font-select .pplr_font')];
        if (fields.length && fields.every((field) => initializedFonts.has(field))) clearInterval(timer);
      }, 500);
      const observer = new MutationObserver(() => sync(root));
      observer.observe(root, { subtree: true, childList: true, attributes: true,
        attributeFilter: ['style', 'class', 'data-value'] });
      ['focusin', 'input', 'change', 'click'].forEach((name) => {
        root.addEventListener(name, () => sync(root), true);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach, { once: true });
  } else attach();
  new MutationObserver(attach).observe(document.documentElement, { childList: true, subtree: true });
})();
